'use client'

import React from 'react'

import LazyVideo from '@/components/Common/LazyVideo'
import { AnimationChildrenProps } from '@/components/LandingPage/ContentModel/Animation'
import { ContentModelVideoType } from '@/types/ContentModel/ContentModelVideo'

export default function Video({
  contentModel,
  animationRef = null,
  style = {},
  className = '',
}: { contentModel: ContentModelVideoType } & AnimationChildrenProps) {
  if (contentModel.creative === undefined || contentModel.creative === null) {
    return <></>
  }

  return (
    <LazyVideo
      animationRef={animationRef as React.Ref<HTMLDivElement>}
      {...(contentModel.id ? { id: contentModel.id } : {})}
      style={style}
      className={className}
      src={contentModel.creative.publishUrl}
      width={contentModel.width != undefined ? parseInt(contentModel.width) : contentModel.creative.width}
      height={contentModel.height != undefined ? parseInt(contentModel.height) : contentModel.creative.height}
      type={contentModel.creative.contentType}
    />
  )
}
